import React, { useEffect, useRef, useState } from "react";
import { AiFillPrinter } from "react-icons/ai";
import { useLocation } from "react-router-dom";
import ReactToPrint from "react-to-print";
import axios from "axios";
import { useGetReturnlistQuery } from "../../features/api/returnlistApi";
import { useGetReturnsQuery } from "../../features/api/returnApi";
import { useGetDealersQuery } from "../../features/api/dealerApi";
import { useGetProductQuery } from "../../features/api/productApi";

function ReturnReport() {
  // useRef for report
  const componentRef = useRef();
  // get data from state and uselocation
  const location = useLocation();
  const returnInvoice = location?.state?.row;
  const dName = location?.state?.dName;
  //   const returnInvoice = location?.state;
  const return_no = returnInvoice?.return_no;

  const { data: returnlist, isLoading: listIsLoading } = useGetReturnlistQuery(
    null,
    {
      refetchOnMountOrArgChange: true,
    }
  );
  const returnProducts = returnlist?.returns;

  const { data: prodct } = useGetProductQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const products = prodct?.products;

  const { data, isLoading: returnIsLoading } = useGetReturnsQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const returns2 = data?.returnTwo;

  //   const filteredItems = returns2?.filter(
  //     (item) =>
  //       item?.dealer === orderInvoice?.dealer && parseInt(item?.inv_no) < invoice_no
  //   );
  //   const sumOfTotal=filteredItems?.reduce((sum,item)=>sum+item?.total,0)
  //   const sumOfPaid=filteredItems?.reduce((sum,item)=>sum+item?.paid,0)
  //   const totalPrevDue =sumOfTotal-sumOfPaid;

  const { data: dlr } = useGetDealersQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const dealers = dlr?.dealer;

  // filter for select invoice
  const filterReturns = returnProducts?.filter(
    (returns) => returns?.return_no === return_no
  );

  const filterDealer = dealers?.filter(
    (d) => d?.d_name === returnInvoice?.dealer
  );
  const findDealer = filterDealer?.find((d) => d);

  // function for formated date
  function formatDate(dateString) {
    const date = new Date(dateString);
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let getDate = day + "-" + month + "-" + year;
    return getDate;
  }

  return (
    <div className="w-full max-w-[1280px] mx-auto px-6 md:px-auto h-[90vh] overflow-auto">
      <ReactToPrint
        trigger={() => (
          <h1 className="cursor-pointer flex items-center absolute right-5 gap-x-1 text-red-500">
            <AiFillPrinter /> Print
          </h1>
        )}
        content={() => componentRef.current}
        pageStyle="@page { size: A4;  margin: 1cm; } @media print { body { -webkit-print-color-adjust: exact; } }"
      />

      <div ref={componentRef}>
        <div>
          <div className="flex flex-col  ">
            <div className="text-center w-full my-6 py-1 font-serif">
              <h1
                className="bg-black bg-opacity-60 text-white text-sm font-bold "
                style={{ letterSpacing: "4px" }}
              >
                Invoice
              </h1>
              <div className="text-center">
                <h2 className="font-bold">Pixel Graphics & Printers</h2>
                <p>
                  {" "}
                  51-51/A, Resorsfull Paltan City (G Floor), Purana Paltan Dhaka
                  - 1000.
                </p>
                <p>01757-672696</p>
                <p>
                  <span className="">Email:</span> pixelgraphicsp@gmail.com
                </p>
              </div>
            </div>
            <div className="flex justify-between">
              <div className="text-sm">
                <h1>
                  <span className="font-bold md:mr-4">Name:</span>{" "}
                  {dName?.d_name}
                </h1>
                <h1>
                  <span className="font-bold md:mr-3">Phone:</span>{" "}
                  {dName?.d_phone}
                </h1>
                <h1>
                  <span className="font-bold md:mr-4">Email:</span>{" "}
                  {dName?.d_email}
                </h1>
                <h1>
                  <span className="font-bold">Address:</span> {dName?.d_address}
                </h1>
              </div>
              <div className="text-sm">
                <h2>
                  <span className="font-bold">Invoice No:</span> {return_no}
                </h2>
                <h2>
                  <span className="font-bold">Invoice Date:</span>{" "}
                  {formatDate(returnInvoice?.return_date)}
                </h2>
              </div>
            </div>
            <div className="flex justify-between gap-2 my-2 border-b border-gray-400 pb-1"></div>
            <div>
              <table className="min-w-full bg-white text-sm">
                <thead>
                  <tr>
                    <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider">
                      Sl No.
                    </th>
                    <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider">
                      Product Name
                    </th>

                    <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider">
                      Quantity
                    </th>
                    <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider">
                      Unit Price
                    </th>
                    <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider">
                      Total
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filterReturns?.map((data, index) => {
                    const proName = products?.find(
                      (pro) => pro?.id === data?.pro_name
                    );
                    return (
                      <tr key={index}>
                        <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                          {index + 1}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                          {proName?.product_name}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                          {data?.qty}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                          {data?.sales_rate}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                          {data?.total}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
                <thead>
                  <tr className="">
                    <th
                      colSpan={4}
                      className="px-6 py-3 border-b-2 border-gray-300 text-right text-xs font-semibold uppercase tracking-wider"
                    >
                      Sub-Total:
                    </th>
                    <th
                      colSpan={2}
                      className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider"
                    >
                      {returnInvoice?.total}
                    </th>
                  </tr>
                </thead>
              </table>
            </div>
            <div className="flex justify-end mt-10">
              {/* <p>
                <span className="font-bold">Dealer Signature: </span>
                ...................................
              </p> */}
              <p>
                <span className="font-bold">Seller Signature: </span>
                ...................................
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReturnReport;